"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsAudioInput = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _JoinComponent = require("../JoinComponent.styled");
var _hooks = require("../../../hooks");
var _utils = require("../utils");
var _metrics = require("@studio/metrics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SettingsAudioInput = exports.SettingsAudioInput = (0, _react.memo)(function (_ref) {
  var _audioInputDevices$fi;
  var meetingSession = _ref.meetingSession,
    selectedAudioInputId = _ref.selectedAudioInputId,
    onAudioInputChange = _ref.onAudioInputChange,
    isDisabled = _ref.isDisabled;
  // Preserves original selectedAudioInputId in case of disconnect
  // This id will then be used to reconnect if device becomes available
  var _useState = (0, _react.useState)(selectedAudioInputId),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    originalDeviceId = _useState2[0],
    setOriginalDeviceId = _useState2[1];
  var _useCommonPageActions = (0, _metrics.useCommonPageActionsApi)(),
    microphoneChanged = _useCommonPageActions.microphoneChanged;
  var handleManualChange = function handleManualChange(deviceId, audioInputName) {
    setOriginalDeviceId(deviceId);
    onAudioInputChange(deviceId);
    microphoneChanged({
      microphoneName: audioInputName
    });
  };
  var audioInputDevices = (0, _utils.formatDevicesArrayForDropdown)((0, _hooks.useAudioInputDevices)({
    meetingSession: meetingSession,
    selectedAudioInputId: selectedAudioInputId,
    onAudioInputChanged: onAudioInputChange
  }));

  // A bluetooth device and fallback device can both have 'default' as deviceId
  // groupId is used to distinguish between them by specifying when the hardware has changed.
  // This check ensures the useEffect triggers and updates which device is being used.
  var selectedGroupId = audioInputDevices === null || audioInputDevices === void 0 ? void 0 : (_audioInputDevices$fi = audioInputDevices.find(function (device) {
    return device.value === selectedAudioInputId;
  })) === null || _audioInputDevices$fi === void 0 ? void 0 : _audioInputDevices$fi.group;

  // Handles fallback to default when bluetooth device disconnects PROD-215932
  (0, _react.useEffect)(function () {
    if (!originalDeviceId || !onAudioInputChange) return;
    var deviceConnected = audioInputDevices.find(function (option) {
      return option.value === originalDeviceId;
    });
    if (!deviceConnected) {
      var _audioInputDevices$;
      onAudioInputChange((_audioInputDevices$ = audioInputDevices[0]) === null || _audioInputDevices$ === void 0 ? void 0 : _audioInputDevices$.value);
    } else {
      onAudioInputChange(originalDeviceId);
    }
  }, [onAudioInputChange, originalDeviceId, audioInputDevices]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_JoinComponent.StyledFormDropdown, {
    labelText: "Select and test microphone",
    "data-testid": "selectMicrophone",
    selected: selectedAudioInputId,
    options: audioInputDevices,
    id: "selectMicrophone",
    onChange: handleManualChange,
    disabled: isDisabled
  }), _react["default"].createElement(_JoinComponent.StyledMicrophoneVolumeBar, {
    selectedAudioInputId: selectedAudioInputId,
    selectedGroupId: selectedGroupId,
    disabled: isDisabled
  }));
});